/* TAMBUR — karusell (flera instanser per sida)
   Refaktorerad från Askås inline-script: scopar all logik per [data-carousel]-rot
   så att flera karuseller på samma sida fungerar oberoende.
   Init är idempotent (data-carousel-init) så Shopifys section-reload inte dubbelbinder. */
(function () {
  function stepCard(track) {
    return track.querySelector('.tambur-carousel-v2__card')
      || track.querySelector('.tambur-mobile-nav__carousel-item')
      || track.querySelector('.tambur-product-card')
      || track.firstElementChild;
  }

  function initCarousel(root) {
    if (root.dataset.carouselInit === '1') return;
    root.dataset.carouselInit = '1';

    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prevBtn = root.querySelector('[data-carousel-dir="prev"]');
    var nextBtn = root.querySelector('[data-carousel-dir="next"]');

    function step() {
      var card = stepCard(track);
      if (!card) return 360;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 14;
      return card.getBoundingClientRect().width + gap;
    }
    function updateButtons() {
      var max = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 2;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var isDown = false, startX, startScroll, hasMoved;
    track.addEventListener('mousedown', function (e) {
      isDown = true; hasMoved = false;
      startX = e.pageX; startScroll = track.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      if (isDown) { isDown = false; track.classList.remove('is-dragging'); }
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4 && !hasMoved) { hasMoved = true; track.classList.add('is-dragging'); }
      if (hasMoved) { e.preventDefault(); track.scrollLeft = startScroll - dx; }
    });
    track.addEventListener('click', function (e) {
      if (track.classList.contains('is-dragging')) e.preventDefault();
    }, true);

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify tema-editor: initiera nyladdade/omladdade sektioner
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-carousel]').forEach(initCarousel);
  });

  // Relaterade produkter hämtas efter sidladdning — då finns inte banan än.
  document.addEventListener('tambur:carousel-init', initAll);
})();

(function () {
  var bodyClass = 'tambur-product-panel-open';

  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.tambur-product-drawer.is-open')) {
      document.body.classList.remove(bodyClass);
    }
  }

  function openPanel(id) {
    document.querySelectorAll('.tambur-product-drawer.is-open').forEach(closePanel);
    var panel = document.querySelector('[data-product-panel="' + id + '"]');
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add(bodyClass);
    var dialogPanel = panel.querySelector('.tambur-product-drawer__panel');
    if (dialogPanel) dialogPanel.focus();
  }

  function getCloseIcon(btn) {
    return btn.querySelector('.tambur-product-drawer__close-icon') || btn.querySelector('svg');
  }

  function bindCloseSpin(btn, onFinish) {
    if (!btn || btn.getAttribute('data-close-spin-bound') === 'true') return;
    btn.setAttribute('data-close-spin-bound', 'true');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-spinning')) return;
      var icon = getCloseIcon(btn);
      if (!icon) {
        onFinish();
        return;
      }
      var finished = false;
      function finishClose() {
        if (finished) return;
        finished = true;
        icon.removeEventListener('animationend', finishClose);
        clearTimeout(fallback);
        btn.classList.remove('is-spinning');
        onFinish();
      }
      var fallback = setTimeout(finishClose, 450);
      btn.classList.remove('is-spinning');
      void btn.offsetWidth;
      btn.classList.add('is-spinning');
      icon.addEventListener('animationend', finishClose);
    });
  }

  function init(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('.tambur-product-drawer__close').forEach(function (btn) {
      bindCloseSpin(btn, function () {
        closePanel(btn.closest('[data-product-panel]'));
      });
    });
  }

  if (!window.__tamburProductPanelsBound) {
    window.__tamburProductPanelsBound = true;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-product-panel-open]');
      if (openBtn) {
        e.preventDefault();
        openPanel(openBtn.getAttribute('data-product-panel-open'));
        return;
      }
      var closeTarget = e.target.closest('[data-product-panel-close]');
      if (closeTarget && !closeTarget.classList.contains('tambur-product-drawer__close')) {
        closePanel(closeTarget.closest('[data-product-panel]'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.tambur-product-drawer.is-open').forEach(closePanel);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
